<template>
  <div>
    <section>
      <v-container container--fluid grid-list-xl>
        <v-row align="center">
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Search Your Invoice</h1>
          </v-col>
        </v-row>

             <v-row align="center" justify="space-around" class="my-8" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col md="5" sm="12" cols="10">

                 <v-row class="flex-column">
                  <v-col cols="12">
                    <v-dialog
                      ref="dialogFrom"
                      v-model="modalFrom"
                      :return-value.sync="fromDate"
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="fromDate"
                          label="From Date"
                          prepend-icon="event"
                          readonly
                          @click.native="modalFrom = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fromDate"
                        scrollable :max="today"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="blue-grey lighten-2" @click="modalFrom = false">Cancel</v-btn>
                        <v-btn text color="blue darken-1" @click="$refs.dialogFrom.save(fromDate)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12">
                    <v-dialog
                      ref="dialogTo"
                      v-model="modalTo"
                      :return-value.sync="toDate"
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="toDate"
                          label="To Date"
                          prepend-icon="event"
                          readonly
                          @click.native="modalTo = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="toDate"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="blue-grey lighten-2" @click="modalTo = false">Cancel</v-btn>
                        <v-btn text color="blue darken-1" @click="$refs.dialogTo.save(toDate)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                   <v-col cols="12" class="text-center">
                     <v-btn text color="indigo lighten-3" @click="clear">Clear</v-btn>
                     <v-btn text outlined color="blue darken-1" @click="getInvoicesFromDates">Search</v-btn>
                   </v-col>

                 </v-row>
              </v-col>

              <v-col md="5" sm="12" cols="10">

                 <v-row align="center">
                  <v-col class="text-center">
                    <h3>Look for a specific invoice</h3>
                  </v-col>
                 </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      placeholder="Invoice No..."
                      v-model="invoiceNo"
                      prepend-icon="fas fa-briefcase"
                      v-on:keyup.enter="getInvoiceFromInvoiceNo"
                    ></v-text-field>
                  </v-col>
                  <v-row>
                    <v-col cols="12" style="text-align: center">
                      <v-btn text outlined color="blue darken-1"  @click="getInvoicesFromInvoiceNo">
                       {{$vuetify.breakpoint.smAndDown ? 'Search' : 'Search with invoice number'}}
                      </v-btn>
                    </v-col>
                  </v-row>

                </v-row>

              </v-col>
             </v-row>


          </v-container>
    </section>

    <section>
      <InvoicesDataTable :invoices="invoices" :searching="searching"
                         :display-message="displayMessage" :editArray="editArray"
                         :total-invoices="invoices.length"
                         :key="keyDataTable"
                         ref="table"
      ></InvoicesDataTable>
    </section>

    <v-dialog
      v-model="alertDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          {{message}}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue darken-1" @click="alertDialog=false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import InvoicesDataTable from "./InvoicesDataTable";

// @vuese Invoice page header used to look for a specific invoice
// @group Invoices
export default {
  name: "SearchForInvoice",
  components: {InvoicesDataTable},
  props: {},
  data() {
    return {
      fromDate: null,
      toDate: null,
      today: new Date().toISOString().substr(0, 10),
      modalFrom: false,
      modalTo: false,
      maxFrom: Math.min(this.today, this.toDate),
      invoiceNo: '',
      invoices: [],
      alertDialog: false,
      message: '',
      searching: false,
      regions: null,
      editArray: [],
      keyDataTable: 0,

    }
  },
  methods: {
    // @vuese
    // Gets all the invoices from a particular invoiceNo
    getInvoicesFromInvoiceNo() {
      this.searching = true;
      axios.get(process.env.API_URL + '/invoices/' + this.invoiceNo)
        .then((response) => {
          if (response.status === 200) {
            this.invoices = response.data;

            for (var i = 0; i < this.invoices.length; i++) {
              this.editArray.push(false);
            }
            this.keyDataTable += 1;

          } else {
            this.displayMessage('ERROR ' + response.status + 'while getting the Invoices data.');
          }
          this.searching = false;
          this.$vuetify.goTo(this.$refs.table, {offset: 50, duration: 1000});
        })
        .catch((error) => {
          this.displayMessage('ERROR ' + error.response.status + 'while getting the Invoices data.');
          this.searching = false;
        })
    },
    // @vuese
    // Gets all the invoices from a particular date.
    // fromDate and toDate are optional arguments if none the API will return the last 2 weeks invoices.
    getInvoicesFromDates() {
      this.searching = true;
      if (this.fromDate !== null && this.fromDate !== undefined) {
        if (this.toDate !== null && this.toDate !== undefined) {
          var request = axios.get(process.env.API_URL + '/invoices?from=' + this.fromDate + '&to=' + this.toDate);
        } else {
          var request = axios.get(process.env.API_URL + '/invoices?from=' + this.fromDate);
        }
      } else {
        var request = axios.get(process.env.API_URL + '/invoices');
      }
      request.then((response) => {
        if (response.status === 200) {
          this.invoices = response.data;

          for (var i = 0; i < this.invoices.length; i++) {
            this.editArray.push(false);
          }
          this.keyDataTable += 1;

        } else {
          this.message = 'ERROR ' + response.status + 'while getting the Invoices data.'
          this.alertDialog = true;
        }
        this.searching = false;
        this.$vuetify.goTo(this.$refs.table, {offset: 50, duration: 1000});
      })
        .catch((error) => {
          this.displayMessage('ERROR ' + error.response.status + 'while getting the Invoices data.');
          this.searching = false;
        })

    },
    // @vuese
    // Takes a string argument and displays it in a dialog
    displayMessage(message) {
      this.message = message;
      this.alertDialog = true;
    },
    // @vuese
    // Clears fromDate and toDate fields
    clear() {
      this.fromDate = null;
      this.toDate = null;
    }

  },
  mounted() {
    // GET THE URL PARAMETERS
    if ((this.$route.query.from !== null && this.$route.query.from !== undefined) && (this.$route.query.to !== null && this.$route.query.to !== undefined)) {
      this.toDate = this.$route.query.to;
      this.fromDate = this.$route.query.from;
      this.getInvoicesFromDates();
    } else if (this.$route.query.from !== null && this.$route.query.from !== undefined) {
      this.fromDate = this.$route.query.from;
      this.getInvoicesFromDates();

    } else if (this.$route.query.to !== null && this.$route.query.to !== undefined) {
      this.toDate = this.$route.query.to;
      this.getInvoicesFromDates();
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Invoices/SearchForInvoice.vue